<template>
  <div class="waf-tabs">
    <ul class="tabs-wrap">
      <li :class="{'active':isActive('teams')}">
        <a :href="getTabLink(current_match, 'teams')">
          {{ translations['lineup_ndtv_label'] }}
        </a>
      </li>
      <li :class="{'active':isActive('tips')}">
        <a :href="getTabLink(current_match, 'tips')">
          {{ translations['match_info_ndtv_label'] }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import { createNdtvSlug } from '../../assets/js/common';
import {CFG_MODULES} from "../../assets/js/config";

export default {
  name: "TopTabs",
  props: ["current_match"],
  data() {
    return {
      CFG_MODULES
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    isActive(name) {
      if(this.$route && this.$route.name && this.$route.name.includes(name)){
        return true;
      } else {
        let urlStr = (typeof window === "undefined") ? (this.$route && this.$route.fullPath) : window.location.href;
        if(name === 'teams') { return urlStr.includes('fantasytips'); }
        else if(name === 'tips') { return urlStr.includes('matchtips'); }
        else { return false; }
      }
    },
    getTabLink(match, page) {
      if (page === 'teams' && !match.show_lineup) return null;
      if (page === 'tips' && !match.slug) return null;
      
      let fullUrl, path, searchStr;
      if(typeof window === "undefined"){
        fullUrl = this.$route && this.$route.fullPath;
        path = this.$route && this.$route.path;
        searchStr = fullUrl ? fullUrl.replace(path, '') : '';
      } else {
        searchStr = window.location.search;
        path = window.location.pathname;
        fullUrl = `${path}${searchStr}`;
      }

      if(fullUrl.includes('/apps/')) {
        let templatePage = "";
        if(page === 'teams') { templatePage = "fantasytips" }
        else if(page === 'tips') { templatePage = "matchtips"; }
        return `/apps/cricket/live-scores/${match.code}?template=${templatePage}&taboola=1&appsource=android&is_mobile=1`;
      } else {
          let hindi = fullUrl.includes('/hindi/') ? '/hindi' : '';
          let tabPath = (page === 'tips') ? '/match-tips' : '/fantasy-tips';
          let ndtvSlug = createNdtvSlug(match);
          return `${hindi}/cricket${tabPath}/${ndtvSlug}${searchStr}`;
      }
    },
  }
}
</script>
